export default {
      id: "tpms_wheel-usage",
      viewBox: "0 0 27 31",
      url: __webpack_public_path__ + "img/icons.svg#tpms_wheel",
      toString: function () {
        return this.url;
      }
    }